//    *GENERAL IMPORTS*   //
import { ThunkAction } from "redux-thunk"
import { AppStateType, InferActionsTypes } from "Redux/ReduxStore"

import { ExpositionType } from "Redux/Types/ExpositionsTypes"

////////////////////////////////////////////////////////////////////////

const initialState = {
  expositions: [] as Array<ExpositionType>,
}

type initialStateType = typeof initialState

// *REDUCER* //
const ExpositionsReducer = (
  state = initialState,
  action: ActionTypes
): initialStateType => {
  if (action.type === "SET_EXPOSITIONS") {
    return {
      ...state,
      expositions: action.expositions,
    }
  }

  return state
}

export default ExpositionsReducer

///////////////////////////////////////////////////////////////////////

type ActionTypes = InferActionsTypes<typeof ActionCreatorsList>

//    *ACTION CREATORS*   //
export const ActionCreatorsList = {
  setExpositionsActionCreator: (expositions: Array<ExpositionType>) =>
    ({
      type: "SET_EXPOSITIONS",
      expositions,
    } as const),
}

//    *THUNKS*   //
type ThunkType = ThunkAction<Promise<void>, AppStateType, unknown, ActionTypes>

export const getExpositionsThunkCreator = (): ThunkType => {
  return async (dispatch, getState, { getFirebase, getFirestore }: any) => {
    const firestore = getFirestore()

    const expositionsRef = firestore.collection("expositions").orderBy("ID")
    const data: Array<ExpositionType> = await expositionsRef
      .get()
      .then((querySnapshot: any) => {
        let list = querySnapshot.docs.map((doc: any) => doc.data())
        return list
      })

    dispatch(ActionCreatorsList.setExpositionsActionCreator(data))
  }
}
